import { Box } from '@mui/material'
import CustomTabPanel from 'components/custom-tab-panel'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import { useCofreDigitals } from 'contexts/cofre-digital'
import InitialTables from './initial-tables'
import Permissions from './permissions'
import { useStyles } from './styles'

const CofreDigital = () => {
  const { changeTab, selectedTab, tabOptions } = useCofreDigitals()

  const classes = useStyles()

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title text='Cofre Digital' />
        <HeaderModule.tabs
          moduleName='Cofre Digital'
          onChange={changeTab}
          current={selectedTab}
          options={tabOptions}
        />
      </Header>

      <Page>
        <Box className={classes.root}>
          <CustomTabPanel
            value={selectedTab}
            index={0}
            node={<InitialTables />}
          />

          <CustomTabPanel
            value={selectedTab}
            index={1}
            node={<Permissions />}
          />
        </Box>
      </Page>
    </Wrapper>
  )
}

export default CofreDigital
